import {
  base64ToAsciiFAQ,
  asciiToBase64FAQ,
  imageToBase64FAQ,
  base64ToImageFAQ,
  htmlColorCodesFAQ,
  sqlFormatterFAQ,
  htmlFormatterFAQ,
  xmlFormatterFAQ,
  javascriptMinifierFAQ,
  cssMinifierFAQ,
  htmlMinifierFAQ,
  xmlMinifierFAQ,
  jsonMinifierFAQ,
  jsonToHtmlConverterFAQ,
  stringToJsonConverterFAQ,
  jsonToStringFAQ,
  xmlToJsonConverterFAQ,
  jsonToXmlConverterFAQ,
  textToBinaryFAQ,
  binaryToTextFAQ,
  currencyConverterFAQ,
  typescriptMinifierFAQ,
  sqlMinifierFAQ,
  yamlMinifierFAQ,
  pythonFormatterFAQ,
  regexTesterFAQ,
  typescriptFormatterFAQ,
  uuidGeneratorFAQ,
  qrCodeGeneratorFAQ,
  cssFormatterFAQ,
  jwtDecodeFAQ,
  loremIpsumGeneratorFAQ,
} from './faqSchemas';

const faqSchemaMap = {
  'json-to-xml-convertor': jsonToXmlConverterFAQ,
  'xml-to-json-convertor': xmlToJsonConverterFAQ,
  'json-to-string-convertor': jsonToStringFAQ,
  'string-to-json-convertor': stringToJsonConverterFAQ,
  'json-to-html-convertor': jsonToHtmlConverterFAQ,
  'text-to-binary-convertor': textToBinaryFAQ,
  'binary-to-text-convertor': binaryToTextFAQ,
  'currency-convertor': currencyConverterFAQ,
  'json-minifier': jsonMinifierFAQ,
  'xml-minifier': xmlMinifierFAQ,
  'html-minifier': htmlMinifierFAQ,
  'css-minifier': cssMinifierFAQ,
  'javascript-minifier': javascriptMinifierFAQ,
  'typescript-minifier': typescriptMinifierFAQ,
  'sql-minifier': sqlMinifierFAQ,
  'yaml-minifier': yamlMinifierFAQ,
  'css-formatter': cssFormatterFAQ,
  'xml-formatter': xmlFormatterFAQ,
  'html-formatter': htmlFormatterFAQ,
  'sql-formatter': sqlFormatterFAQ,
  'html-color-codes': htmlColorCodesFAQ,
  'python-formatter': pythonFormatterFAQ,
  'typescript-formatter': typescriptFormatterFAQ,
  'regex-tester': regexTesterFAQ,
  'base64-to-image-conversion': base64ToImageFAQ,
  'image-to-base64-conversion': imageToBase64FAQ,
  'base64-to-ascii-conversion': base64ToAsciiFAQ,
  'ascii-to-base64-conversion': asciiToBase64FAQ,
  'jwt-decode': jwtDecodeFAQ,
  'uuid-generator': uuidGeneratorFAQ,
  'lorem-ipsum': loremIpsumGeneratorFAQ,
  'qrcode-generator': qrCodeGeneratorFAQ,
};

export default faqSchemaMap;
